import React, { useEffect, useState } from 'react';

export const LoadingDots = () => {
    const [step, setStep] = useState(0);
    useEffect(() => {
        const timeout = setTimeout(() => setStep(s => (s + 1) % 4), step === 3 ? 1400 : 800);
        return () => clearTimeout(timeout);
    }, [step]);
    return (
        <span style={{ display: 'inline-block', width: '2ch' }}>
            {['.', '.', '.'].map((d, i) => (
                <span key={i} style={{ opacity: i < step ? 1 : 0 }}>
                    {d}
                </span>
            ))}
        </span>
    );
};
